import { Center, Flex, Heading, Link } from "@chakra-ui/react";
import PowerImage from '../../Assets/Images/power.jpg';
import SpaceImage from '../../Assets/Images/nasa-space.jpg';
import CertificationItem from "../CertificationItem";
import AS9100 from '../../Assets/Images/as9100.png';
import ISO45001 from '../../Assets/Images/iso45001.png';
import ISO14001 from '../../Assets/Images/iso14001.png';

const CertificationBanner = () => {
    return (
        <Flex 
            flex='1' 
            width='100%'
            bgImage={ SpaceImage }
            backgroundPosition='center'
            backgroundSize='cover'
            flexDirection='column'
        >
            <Flex marginTop='20px'>
                <Center
                    display='flex'
                    flex='1'>
                    <Heading color='brand.white'>Why choose Virtue Aerospace?</Heading>
                </Center>
            </Flex>
            <Flex
                justifyContent='center'
                marginTop='20px'
                marginBottom='20px'
                flexWrap='wrap'
            >
                <Link href='/docs/Q 09065.pdf' isExternal>
                    <CertificationItem 
                        image={ AS9100 }
                        certIdentifier='Q 09065'
                    />
                </Link>
                <Link href='/docs/OHS 712756 (24.11.2023).pdf' isExternal>
                    <CertificationItem 
                        image={ ISO45001 }
                        certIdentifier='OHS 712756'
                    />
                </Link>
                <Link href='/docs/EMS 740749 (04.07.2028).pdf' isExternal>
                    <CertificationItem 
                        image={ ISO14001 }
                        certIdentifier='EMS 740749'
                    />
                </Link>
            </Flex>
        </Flex>
    );
};

export default CertificationBanner;